import {GetCookieInfo} from "./CookieManager";

export const GetNotificationItemColor = (notification) => {
    switch (notification.type) {
        case 0:
            return 'red';
        case 1:
            return '#A8ED8F';
        case 2:
            return '#77B1FC';
        case 3:
            return 'yellow';
        default:
            return null;
    }
};

export const UpdateNotificationState = async (notificationId, newState) => {
    try {
        const tokenCookie = GetCookieInfo('nplt');
        const response = await fetch(
            `${process.env.REACT_APP_NOTIFICATIONS_URL}/state`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + tokenCookie.value,
                },
                body: JSON.stringify({
                    notificationId: notificationId,
                    newState: newState
                })
            }
        );
        if (response.ok) {
            const data = await response.json();
            return data.success;
        } else {
            console.log('State updating failed.');
            return false;
        }
    } catch (error) {
        console.log('An error occurred:', error);
        return false;
    }
};